import { useIntl } from 'react-intl';

import type { Sport } from '#src/__generated__/globalTypes.ts';
import { HomeIcon } from '#src/atoms/icons/HomeIcon.tsx';
import { NavItem } from '#src/components/navigation/NavItem/index.tsx';
import { ANY_SPORT_HOME } from '#src/constants/__generated__/routes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { useEnableSorare27Nav } from '#src/hooks/useEnableSorare27Nav.ts';
import { navLabels } from '#src/lib/glossary.ts';
import { generateSportPath } from '#src/lib/routing/generateSportPath.ts';

import { useNavItemLayout } from '../useNavItemLayout.ts';

type Props = { sport: Sport; sidebarCollapsed?: boolean };

export const HomeNavItem = ({ sport, sidebarCollapsed }: Props) => {
  const { formatMessage } = useIntl();
  const { navItemsVariant, iconSize } = useNavItemLayout();
  const seriesNav = useSeriesNav();
  const isSorare27Nav = useEnableSorare27Nav();
  const { currentUser } = useCurrentUserContext();

  if (seriesNav || isSorare27Nav) {
    return null;
  }

  return (
    <NavItem
      variant={navItemsVariant}
      icon={() => <HomeIcon size={iconSize} />}
      label={formatMessage(navLabels.home)}
      to={generateSportPath(ANY_SPORT_HOME, { sport })}
      sidebarCollapsed={sidebarCollapsed}
      badge={{
        content: currentUser?.myUnclaimedTasksCount,
      }}
      enableContextModeNavigation
    />
  );
};
